import React from 'react'

import style from '@styles/account/AccountSettings.module.scss'

interface Props {
  title: string
  description: string
  buttonText: string
  onButtonClick: () => unknown
}

const AccountSettings = ({ title, description, buttonText, onButtonClick }: Props) => (
  <div className={style.container}>
    <h2 className={style.title}>{title}</h2>
    <div className={style.content}>
      <div className={style.description}>{description}</div>
      <div>
        <button className={style.button} onClick={onButtonClick}>
          {buttonText}
        </button>
      </div>
    </div>
  </div>
)

export { AccountSettings }
